if (!customElements.get("picker-tile")) {
  customElements.define(
    "picker-tile",
    class PickerTile extends HTMLElement {
      constructor() {
        super();
        this.bundlePickerDrawer = document.querySelector("product-drawer");
        this.actionButton = this.querySelector(".bundle-picker__tile-close");
        this.bundleAddToCart = document.querySelector("#AddToCart");
        this.drawerProductSelections = Array.from(
          document.querySelectorAll(".product-drawer__product-list")
        );
        this.associatedProductList = this.drawerProductSelections.find(
          (selection) => selection.dataset.selection === this.dataset.selection
        );
      }

      connectedCallback() {
        this.addEventListener("click", this.handleTileClick.bind(this));

        this.actionButton.addEventListener(
          "click",
          this.handleActionButton.bind(this)
        );
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleTileClick.bind(this));
        this.actionButton.removeEventListener(
          "click",
          this.handleActionButton.bind(this)
        );
      }

      handleTileClick() {
        this.bundlePickerDrawer = document.querySelector("product-drawer");
        if (!this.bundlePickerDrawer) return;

        this.drawerProductSelections = Array.from(
          this.bundlePickerDrawer.querySelectorAll(".product-drawer__product-list")
        );
        this.associatedProductList = this.drawerProductSelections.find(
          (selection) => selection.dataset.selection === this.dataset.selection
        );

        this.bundlePickerDrawer.setAttribute(
          "data-current-product",
          this.dataset.position
        );

        this.drawerProductSelections.forEach((selection) => {
          selection.setAttribute("hidden", "");
        });

        if (this.associatedProductList) {
          this.associatedProductList.removeAttribute("hidden");
        }
      }

      handleActionButton(event) {
        if (!this.actionButton.getAttribute("data-action")) {
          return;
        }

        switch (this.actionButton.getAttribute("data-action")) {
          case "remove":
            this.remove();
            document.querySelector("product-drawer")?.updateAddToCartPrice();
            break;
          case "replace":
            this.replaceContent();
            break;
          default:
            return;
        }
      }

      replaceContent() {
        const tileImage = this.querySelector(".bundle-picker__image");
        const titleHeading = this.querySelector(".tile__title-heading");
        const titleSubHeading = this.querySelector(".tile__title-subheading");
        this.bundleAddToCart = document.querySelector("#AddToCart");

        this.removeAttribute("aria-checked");
        titleHeading.textContent = this.dataset.heading;
        titleSubHeading.textContent = this.dataset.subheading;
        tileImage.src = this.dataset.placeholderImage;
        if (this.bundleAddToCart) {
          this.bundleAddToCart.disabled = true;
          this.bundleAddToCart.classList.remove("button--primary");
          this.bundleAddToCart.classList.add("button--ternary");
          const loaderText = this.bundleAddToCart.querySelector(".loader-button__text");
          if (loaderText) {
            loaderText.textContent = window.translations.bundles.chooseAllProducts;
          }
        }

        // Notify ProductDrawer that this tile position was cleared
        document.dispatchEvent(
          new CustomEvent("bundle-tile-cleared", {
            detail: { position: this.dataset.position },
          })
        );

        //25.04.26
        const allTiles = Array.from(
          document.querySelectorAll("[data-tile='bundle-product']")
        );
        const checkedTiles = allTiles.filter((tile) =>
          tile.hasAttribute("aria-checked")
        );
        const infoBox = document.querySelector(".bb-selected-info");
        const messageEl = document.querySelector(".bb-selected-txt p");

        if (infoBox && messageEl) {
          if (checkedTiles.length === 0) {
            infoBox.style.display = "none";
          } else {
            const lastCheckedName = checkedTiles[checkedTiles.length - 1]
              .querySelector(".tile__title-heading")?.textContent?.trim() || "";
            const totalSlots = allTiles.length;
            const isLast = checkedTiles.length >= totalSlots;
            const suffix = isLast
              ? "Your set is now ready!"
              : "Great look! Choose your next design";
            infoBox.style.display = "flex";
            messageEl.innerHTML = `<span>${lastCheckedName} successfully selected</span> ${suffix}`;
          }
        }
        //END 25.04.26
      }
    }
  );
}

// Shared filter state + logic for nail-type-filter and drawer-filter
const ProductListFilters = {
  // Returns the shared state object for a given product list element
  getState(productList) {
    if (!productList._filterState) {
      productList._filterState = { nailType: null, form: null };
    }
    return productList._filterState;
  },

  // Re-evaluate all wrappers against current state
  apply(productList) {
    const state = this.getState(productList);
    const allWrappers = Array.from(
      productList.querySelectorAll(".product-drawer__item-wrapper")
    );

    allWrappers.forEach((wrapper) => {
      const item = wrapper.querySelector("[data-nail-type], [data-filter]");
      if (!item) return;

      const nailType = item.dataset.nailType || null;
      const form = item.dataset.filter || null;

      const nailMatch = !state.nailType || nailType === state.nailType;
      const formMatch = !state.form || form === state.form;

      if (nailMatch && formMatch) {
        wrapper.removeAttribute("hidden");
      } else {
        wrapper.setAttribute("hidden", "");
      }
    });
  },
};

if (!customElements.get("drawer-filter")) {
  customElements.define(
    "drawer-filter",
    class DrawerFilter extends HTMLElement {
      constructor() {
        super();

        this.drawerProductList = this.closest(".product-drawer__product-list");
        this.filterValues = Array.from(
          this.querySelectorAll(".drawer-filter__value")
        );

        this.handleFilterClick = this.handleFilterClick.bind(this);
      }

      connectedCallback() {
        if (this.filterValues) {
          this.filterValues.forEach((value) => {
            value.addEventListener("click", () => {
              this.handleFilterClick(value);
            });
          });
        }
      }

      disconnectedCallback() {
        if (this.filterValues) {
          this.filterValues.forEach((value) => {
            value.removeEventListener("click", () => {
              this.handleFilterClick(value);
            });
          });
        }
      }

      handleFilterClick(value) {
        if (value.classList.contains("active")) {
          value.classList.remove("active");
        } else {
          this.filterValues.forEach((filterValue) => {
            filterValue.classList.remove("active");
          });
          value.classList.add("active");
        }

        const activeFilter = this.filterValues.find((filterValue) =>
          filterValue.classList.contains("active")
        );

        // Update shared state and re-apply both filters
        const state = ProductListFilters.getState(this.drawerProductList);
        state.form = activeFilter ? activeFilter.dataset.value : null;
        ProductListFilters.apply(this.drawerProductList);
      }
    }
  );
}

if (!customElements.get("nail-type-filter")) {
  customElements.define(
    "nail-type-filter",
    class NailTypeFilter extends HTMLElement {
      constructor() {
        super();
        this.drawerProductList = this.closest(".product-drawer__product-list");
        this.filterValues = Array.from(
          this.querySelectorAll(".drawer-filter__value")
        );
        this.handleFilterClick = this.handleFilterClick.bind(this);
      }

      connectedCallback() {
        this.filterValues.forEach((value) => {
          value.addEventListener("click", () => this.handleFilterClick(value));
        });
      }

      disconnectedCallback() {
        this.filterValues.forEach((value) => {
          value.removeEventListener("click", () =>
            this.handleFilterClick(value)
          );
        });
      }

      handleFilterClick(value) {
        const isAlreadyActive = value.classList.contains("active");

        this.filterValues.forEach((v) => v.classList.remove("active"));
        if (!isAlreadyActive) {
          value.classList.add("active");
        }

        // Update shared state and re-apply both filters
        const state = ProductListFilters.getState(this.drawerProductList);
        state.nailType = isAlreadyActive ? null : value.dataset.value;
        ProductListFilters.apply(this.drawerProductList);

        // Disable drawer-filter when Toenails is selected
        const formFilter = this.drawerProductList
          ? this.drawerProductList.querySelector("drawer-filter")
          : null;
        if (formFilter) {
          if (state.nailType === "Toenail") {
            formFilter.classList.add("is-disabled");
            
            formFilter.querySelectorAll(".drawer-filter__value").forEach((v) => v.classList.remove("active"));
            state.form = null;
            ProductListFilters.apply(this.drawerProductList);
          } else {
            formFilter.classList.remove("is-disabled");
          }
        }
      }
    }
  );
}

class ProductDrawer extends DrawerContent {
  constructor() {
    super();
    this.currentProduct = null;
    this.onTileCleared = this.onTileCleared.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    // This is for the normal products
    this.drawerItems = Array.from(
      this.querySelectorAll("[data-type='drawer-product']")
    );
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    // This is for the optionalItems
    this.optionalProductTiles = Array.from(
      document.querySelectorAll("[data-tile='optional-product']")
    );
    this.optionalProductsWrapper = document.querySelector(
      ".optional-products .bundle-picker__wrapper"
    );

    if (this.optionalProductsWrapper) {
      this.originalOptionalTile = document
        .querySelector("[data-tile='optional-product']")
        .cloneNode(true);

      this.optionalItems = Array.from(
        this.querySelectorAll("[data-type='optional-product']")
      );
    }

    // This is for the add to cart
    this.bundleAddToCart = document.querySelector("#AddToCart");

    // This is for the quick view buttons
    this.quickViewLayer = this.querySelector(".product-drawer__quick-view");
    this.closeQuickViewLayer = this.quickViewLayer.querySelector(
      ".drawer__layer-close"
    );

    this.quickViewButtons = this.querySelectorAll(
      ".product-drawer__item-quick-view-button"
    );
    this.quickViewSlider = null;
    this.quickViewHeading = this.quickViewLayer.querySelector(
      "#QuickViewTitle"
    );
    this.quickViewAddButton =
      this.quickViewLayer.querySelector("#QuickViewAdd");

    this.addListeners();
  }

  disconnectedCallback() {
    document.removeEventListener("bundle-tile-cleared", this.onTileCleared);
    if (typeof super.disconnectedCallback === "function") {
      super.disconnectedCallback();
    }
  }

  onTileCleared(event) {
    if (!this.selectedVariants) return;
    const clearedPosition = event.detail.position;
    for (const [variantId, pos] of Object.entries(this.selectedVariants)) {
      if (pos === clearedPosition) {
        delete this.selectedVariants[variantId];
      }
    }
    this.updateDrawerCheckmarks();
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      const drawerContent = this.querySelector(".drawer__content");
      if (drawerContent) {
        drawerContent.scrollTop = 0;
      }
      const items = Array.from(
          this.querySelectorAll(".product-drawer__item:not([hidden]")
        ),
        effects = [];
      items.forEach((item) => (item.style.opacity = 0));
      effects.push(
        new ParallelEffect(
          items.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: ["translateX(40px)", "translateX(0)"],
              },
              {
                duration: 200, // Further reduced duration
                delay:
                  200 + 60 * index - Math.min(1 * index * index, 60 * index), // Reduced delay calculation
                easing: "cubic-bezier(0.25, 1, 0.5, 1)", // You can also consider simpler easing, like "ease-out"
              }
            );
          })
        )
      );
      let animation = new CustomAnimation(new ParallelEffect(effects));
      animation.play();
    }
  }

  async addListeners() {
    this.closeQuickViewLayer.addEventListener(
      "click",
      this.toggleQuickViewLayer.bind(this)
    );

    this.quickViewButtons.forEach((button) => {
      button.addEventListener("click", this.handleQuickView.bind(this));
    });
    this.quickViewAddButton.addEventListener("click", () => {
      this.handleBundleProductAssignment(this.quickViewAddButton);
      this.handleOptionalProductAssignment(this.quickViewAddButton);
      this.toggleQuickViewLayer();
    });

    document.addEventListener("bundle-tile-cleared", this.onTileCleared);
    
    if (
      !this.drawerItems.length ||
      !this.productTiles.length ||
      !this.bundleAddToCart
    ) {
      return;
    }
    /* OLD Logic for product selection and drawer close
    this.drawerItems.forEach((product) => {
      product.addEventListener("click", () => {
        this.handleBundleProductAssignment(product);
      });
    });
    */

    this.drawerItems.forEach((product) => {
      product.addEventListener("click", (event) => {
        this.handleBundleProductAssignment(product, event);
      });
    });

    if (
      !this.optionalItems ||
      !this.optionalItems.length ||
      !this.optionalProductTiles.length
    ) {
      return;
    }

    this.optionalItems.forEach((product) => {
      product.addEventListener("click", () => {
        this.handleOptionalProductAssignment(product);
      });
    });
  }
/* OLD Logic for product selection and drawer close
  handleBundleProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;

    const currentTile = this.productTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    // Assigning values only if elements exist
    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    currentTile.setAttribute("aria-checked", "true");

    // Refresh bundleTiles in case the DOM has changed
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    if (this.productTiles.every((tile) => tile.hasAttribute("aria-checked"))) {
      if (this.bundleAddToCart) {
        this.bundleAddToCart.disabled = false;
        this.bundleAddToCart.classList.add("button--primary");
        this.bundleAddToCart.classList.remove("button--ternary");

        const loaderButtonText = this.bundleAddToCart.querySelector(
          ".loader-button__text"
        );
        if (loaderButtonText) {
          const addToCartText =
            window.translations?.product?.form?.addToCart || "Add to Cart";
          loaderButtonText.textContent = addToCartText;
        }

        this.updateAddToCartPrice();
      }
    }
    this.updateSelectedInfo(product.dataset.heading);
  }*/

  handleBundleProductAssignment(product, event) {
    this.currentProduct = this.dataset.currentProduct;

    const currentTile = this.productTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    // Assigning values only if elements exist
    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    currentTile.setAttribute("aria-checked", "true");

    // render checkmarks
    if (!this.selectedVariants) this.selectedVariants = {};
    
    for (const [variantId, pos] of Object.entries(this.selectedVariants)) {
      if (pos === this.currentProduct) delete this.selectedVariants[variantId];
    }
    if (product.dataset.variantId) {
      this.selectedVariants[product.dataset.variantId] = this.currentProduct;
    }
    this.updateDrawerCheckmarks();

    // Refresh bundleTiles in case the DOM has changed
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    const allFilled = this.productTiles.every((tile) => tile.hasAttribute("aria-checked"));

    if (allFilled) {
      
      if (this.bundleAddToCart) {
        this.bundleAddToCart.disabled = false;
        this.bundleAddToCart.classList.add("button--primary");
        this.bundleAddToCart.classList.remove("button--ternary");

        const loaderButtonText = this.bundleAddToCart.querySelector(
          ".loader-button__text"
        );
        if (loaderButtonText) {
          const addToCartText =
            window.translations?.product?.form?.addToCart || "Add to Cart";
          loaderButtonText.textContent = addToCartText;
        }

        this.updateAddToCartPrice();
      }
    } else {
      if (event) {
        event.stopImmediatePropagation();
      }
      const nextEmptyTile = this.productTiles.find(
        (tile) => !tile.hasAttribute("aria-checked")
      );

      if (nextEmptyTile) {
        this.dataset.currentProduct = nextEmptyTile.dataset.position;

        const drawerProductSelections = Array.from(
          this.querySelectorAll(".product-drawer__product-list")
        );
        drawerProductSelections.forEach((selection) => {
          selection.setAttribute("hidden", "");
        });
        const nextList = drawerProductSelections.find(
          (selection) =>
            selection.dataset.selection === nextEmptyTile.dataset.selection
        );
        if (nextList) {
          nextList.removeAttribute("hidden");
        }
      }
    }

    this.updateSelectedInfo(product.dataset.heading);
  }

  updateAddToCartPrice() {
    if (!this.bundleAddToCart || this.bundleAddToCart.disabled) return;
    if (typeof formatMoney !== "function") return;

    const loaderButtonText = this.bundleAddToCart.querySelector(
      ".loader-button__text"
    );
    if (!loaderButtonText) return;

    const bundleForm =
      this.bundleAddToCart.closest("form[data-bundle]") ||
      document.querySelector("form[data-bundle]");
    if (!bundleForm) return;

    // The set has a fixed price (data-price on the form), it is NOT the sum of
    // the selected styles — those are discounted down to the set price in cart.
    const bundlePrice = parseFloat(bundleForm.dataset.price || 0);
    if (!bundlePrice) return;

    let totalCents = Math.round(bundlePrice * 100);

    // Optional add-ons are charged on top, minus their bundle discount.
    const optionalDiscount = parseFloat(bundleForm.dataset.optionalDiscount || 0);
    document
      .querySelectorAll("input[data-optional-input]")
      .forEach((input) => {
        if (!input.value) return;
        const price = parseFloat(input.dataset.price || 0);
        if (!price) return;
        totalCents += Math.round(price * 100 * (1 - optionalDiscount / 100));
      });

    const addToCartText =
      window.translations?.product?.form?.addToCart || "Add to Cart";

    // Same markup as the standard product template so the shared
    // .product-form__add-button-* styles apply (see custom.css).
    loaderButtonText.textContent = "";

    const label = document.createElement("span");
    label.className = "product-form__add-button-label";
    label.textContent = addToCartText;

    const separator = document.createElement("span");
    separator.className = "product-form__add-button-separator";
    separator.setAttribute("aria-hidden", "true");
    separator.textContent = "·";

    const price = document.createElement("span");
    price.className = "product-form__add-button-price";
    price.innerHTML = formatMoney(totalCents);

    loaderButtonText.append(label, separator, price);
  }

  //checkmark
  updateDrawerCheckmarks() {
    if (!document.getElementById("drawer-checkmark-styles")) {
      const style = document.createElement("style");
      style.id = "drawer-checkmark-styles";
      style.textContent = `
        .product-drawer__item { position: relative; }
        .drawer-selected-check {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          width: 23px;
          height: 23px;
          background: #ffffff;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          z-index: 2;
        }
        .product-drawer__item.is-selected .drawer-selected-check {
          display: flex;
        }
        .drawer-selected-check svg {
          width: 13px;
          height: 13px;
          fill: none;
          stroke: #ab6a7d;
          stroke-width: 2.5;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
      `;
      document.head.appendChild(style);
    }

    this.drawerItems.forEach((item) => {
      if (!item.querySelector(".drawer-selected-check")) {
        const badge = document.createElement("span");
        badge.className = "drawer-selected-check";
        badge.innerHTML = `<svg viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3"/></svg>`;
        item.appendChild(badge);
      }
      const variantId = item.dataset.variantId;
      if (variantId && this.selectedVariants && this.selectedVariants[variantId]) {
        item.classList.add("is-selected");
      } else {
        item.classList.remove("is-selected");
      }
    });
  }

  updateSelectedInfo(productName) {
    const infoBox = document.querySelector(".bb-selected-info");
    const messageEl = document.querySelector(".bb-selected-txt p");
    if (!infoBox || !messageEl) return;

    const totalSlots = this.productTiles.length;
    const filledSlots = this.productTiles.filter((tile) =>
      tile.hasAttribute("aria-checked")
    ).length;

    if (filledSlots === 0) {
      infoBox.style.display = "none";
      return;
    }

    infoBox.style.display = "flex";

    const isLast = filledSlots >= totalSlots;
    const suffix = isLast
      ? "Gute Wahl! Dein Set ist jetzt komplett!"
      : "Gute Wahl! Wähle dein nächstes Design";

    messageEl.innerHTML = `<span>${productName} hinzugefügt</span> ${suffix}`;
  }

  handleOptionalProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;
    this.optionalProductTiles = Array.from(
      document.querySelectorAll("[data-tile='optional-product']")
    );

    const currentTile = this.optionalProductTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.price && currentTileVariantId) {
      currentTileVariantId.setAttribute("data-price", product.dataset.price);
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    this.updateAddToCartPrice();

    if (currentTile.getAttribute("aria-checked") === "true") {
      return;
    }

    currentTile.setAttribute("aria-checked", "true");

    const newOptionalTile = this.originalOptionalTile.cloneNode(true);
    newOptionalTile.setAttribute(
      "data-position",
      `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`
    );
    newOptionalTile.querySelector(
      "input"
    ).id = `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`;
    this.optionalProductsWrapper.appendChild(newOptionalTile);

    this.updateAddToCartPrice();
  }

  toggleQuickViewLayer() {
    if (this.quickViewLayer.hasAttribute("open")) {
      this.quickViewLayer.removeAttribute("open");
    } else {
      this.quickViewLayer.setAttribute("open", "");
    }
  }

  handleQuickView(event) {
    const quickViewData = event.target
      .closest(".product-drawer__item-wrapper")
      .querySelector(".product-drawer__item");

    const images = quickViewData
      ? JSON.parse(quickViewData.dataset.images)
      : null;
    const slides = images.map((image) => {
      return `
        <div class="swiper-slide">
          <img src="${image}">
        </div>
      `;
    });
    this.quickViewSlider = this.querySelector("swiper-element").swiperInstance;
    this.quickViewSlider.removeAllSlides();
    this.quickViewSlider.appendSlide(slides);
    this.quickViewSlider.update();
    this.quickViewSlider.slideTo(0);
    this.quickViewHeading.textContent = quickViewData.dataset.heading;
    this.quickViewAddButton.setAttribute(
      "data-image",
      quickViewData.dataset.image
    );
    this.quickViewAddButton.setAttribute(
      "data-variant-id",
      quickViewData.dataset.variantId
    );
    this.quickViewAddButton.setAttribute(
      "data-heading",
      quickViewData.dataset.heading
    );
    this.quickViewAddButton.setAttribute(
      "data-subheading",
      quickViewData.dataset.subheading
    );

    this.toggleQuickViewLayer();
  }

  getNextFreeNumber(optionalTiles) {
    const usedNumbers = Array.from(optionalTiles)
      .map((tile) => {
        const match = tile
          .getAttribute("data-position")
          ?.match(/optional-product-(\d+)/);
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num) => num !== null);
    usedNumbers.sort((a, b) => a - b);
    let nextNumber = 1;
    for (const num of usedNumbers) {
      if (num === nextNumber) {
        nextNumber++;
      } else {
        break;
      }
    }

    return nextNumber;
  }
}

window.customElements.define("product-drawer", ProductDrawer);
